import z from 'zod';
import { IAtsEntity } from './atsEntitySchema.js';

export const IAtsCompany = IAtsEntity;
export type IAtsCompany = z.infer<typeof IAtsCompany>;
